import React from "react";

import withTranslations from "../../../../../hocs/withTranslations";
import { STRATEGY_DASHBOARD_TABS } from "../../../../../lib/StrategyDashboard/strategyDashboardConfig";
import { useStrategyDashboardConfig } from "../../../../../lib/StrategyDashboard/StrategyDashboardContext";
import { BodyRegular } from "../../../common/Typography";
import StrategyDashboardBreadcrumb from "./StrategyDashboardBreadcrumb";
import GenericStaticPage from "@/web/components/pages/GenericStaticPage";

const StrategyDashboardDescriptionTab = () => {
  const dashboard = useStrategyDashboardConfig();

  return (
    <div className="bg-white py-8 -mx-3.6 px-4 md:mx-0 md:px-10">
      <StrategyDashboardBreadcrumb page={STRATEGY_DASHBOARD_TABS.DESCRIPTION} />
      <BodyRegular className="mt-5">
        {dashboard.descriptionSlug ? (
          <GenericStaticPage slug={dashboard.descriptionSlug} renderInPlace />
        ) : null}
      </BodyRegular>
    </div>
  );
};

export default withTranslations(StrategyDashboardDescriptionTab);
